export default __webpack_public_path__ + "static/media/S-039.b8a3e651.png";